import $http from './index.js'
export const UpdateUserPassword = (data) => {
  return $http.post('api/User/UpdateUserPassword', data)
}
export const SaveUser = (data) => {
  return $http.post('api/User/SaveUser', data)
}
export const GetUserPageList = (data) => {
  return $http.post('api/User/GetUserPageList', data)
}
export const ImportUserJudges = (data) => {
  return $http.post('api/User/ImportUserJudges', data)
}
export const ImportUserTutor = (data) => {
  return $http.post('api/User/ImportUserTutor', data)
}
export const ResetPassword = (data) => {
  return $http.post('api/User/ResetPassword', data)
}
export const ImportUserStudent = (data) => {
  return $http.post('api/User/ImportUserStudent', data)
}
export const SaveUserJudges = (data) => {
  return $http.post('api/User/SaveUserJudges', data)
}
export const SaveUserStudent = (data) => {
  return $http.post('api/User/SaveUserStudent', data)
}
export const GetUserStudent = (data) => {
  return $http.post('api/User/GetUserStudent', data)
}
export const GetUserJudges = (data) => {
  return $http.post('api/User/GetUserJudges', data)
}
export const GetUserTutor = (data) => {
  return $http.post('api/User/GetUserTutor', data)
}
export const SaveUserTutor = (data) => {
  return $http.post('api/User/SaveUserTutor', data)
}
export const SendFindPwdEmailValidCode = (data) => {
  return $http.post('api/User/SendFindPwdEmailValidCode', data)
}
export const ValidFindPwdValidCode = (data) => {
  return $http.post('api/User/ValidFindPwdValidCode', data)
}
export const FindPwd = (data) => {
  return $http.post('api/User/FindPwd', data)
}
